import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import PageNotFound from '@base/pages/components/pageNotFound';
import VerificationAccountPage from '@base/pages/verificationAccountPage/verificationAccountPage';
import ChangePasswordPage from '@base/pages/components/changePasswordPage';
import Lobby from '@base/pages/components/lobbyPage';
import Game from '@base/pages/components/gamePage';
import ForumPage from '@base/pages/forumPage/forumPage';
import Ladder from '@base/pages/components/ladder';
import Tournaments from '@base/pages/tournamentsPage/tournamentsPage';
import UserInfo from '@base/features/user/components/userInfo';
import ChangeSocialUsernamePage from '@base/pages/components/changeSocialUsernamePage';
import CompleteRegistrationPage from '@base/pages/components/completeRegistrationPage';
import EditAccountPage from '@base/pages/components/editAccountPage';
import PrivateRoute from '@base/features/privateRoute/privateRoute';
import Login from '@base/features/auth/components/login/login';
import Registration from '@base/features/auth/components/registration/registration';
import ForgotPasswordPage from '@base/pages/components/forgotPasswordPage';
import { IUserService } from '../user/model/interfaces';
import { container } from 'tsyringe';
import { IGameProvider } from '../game/model/interfaces';

export function Routes(props: { currentUser?: string }) {
  const userService: IUserService = container.resolve('userService');
  const gameProvider: IGameProvider = container.resolve('gameProvider');

  const privateRoutes = [
    { exact: true, path: MAIN_ROUTES.game, module: <Game /> },
    { exact: true, path: MAIN_ROUTES.lobby, module: <Lobby /> },
    { exact: true, path: MAIN_ROUTES.tournaments, module: <Tournaments /> },
    { exact: false, path: MAIN_ROUTES.help, module: gameProvider.getHelpPage() },
    { exact: false, path: MAIN_ROUTES.forum, module: <ForumPage /> },
    { exact: false, path: MAIN_ROUTES.userInfo, module: <UserInfo /> },
    {
      exact: true,
      path: MAIN_ROUTES.changePassword,
      module: <ChangePasswordPage />,
    },
    {
      exact: true,
      path: MAIN_ROUTES.completeRegistration,
      module: <CompleteRegistrationPage />,
    },
    { exact: true, path: MAIN_ROUTES.ladder, module: <Ladder /> },
    { exact: true, path: MAIN_ROUTES.editAccount, module: <EditAccountPage /> },
  ];
  const publicRoutes = [
    { exact: true, path: '/', module: <Redirect to={MAIN_ROUTES.login} /> },
    {
      exact: false,
      path: MAIN_ROUTES.login,
      redirect: true,
      module: <Login />,
    },
    {
      exact: true,
      path: MAIN_ROUTES.changeSocialUsername,
      redirect: true,
      module: <ChangeSocialUsernamePage />,
    },
    { exact: true, path: MAIN_ROUTES.forgot, module: <ForgotPasswordPage /> },
    {
      exact: true,
      path: MAIN_ROUTES.verification,
      module: <VerificationAccountPage />,
    },
  ];

  return (
    <main className="main">
      <Switch>
        {privateRoutes.map((route) => (
          <PrivateRoute exact={route.exact} isAuth={!!props.currentUser} path={route.path} key={route.path}>
            {route.module}
          </PrivateRoute>
        ))}
        {publicRoutes.map((route) => (
          <Route exact={route.exact} key={route.path} path={route.path}>
            {route.redirect && props.currentUser ? <Redirect to={MAIN_ROUTES.lobby} /> : route.module}
          </Route>
        ))}
        <Route exact={false} key={MAIN_ROUTES.register} path={MAIN_ROUTES.register}>
          {props.currentUser && !userService.isGuestPlayer() ? (
            <Redirect to={MAIN_ROUTES.lobby} />
          ) : (
            <Registration />
          )}
        </Route>
        <Route path="*">
          <PageNotFound />
        </Route>
      </Switch>
    </main>
  );
}
